export default "__VITE_ASSET__DJp_xifL__"